import * as bowser from 'bowser';

/**
 * Reference:
 * https://domoreexp.visualstudio.com/Teamspace/_git/teams-modular-packages?path=%2Fpackages
 * %2Fcore%2Fservices%2Fcore-services-platform%2Fsrc%2Fplatform-service.test.ts&version=GBmaster&_a=contents
 */
export enum PlatformId {
  Android = 1416,
  Desktop = 27,
  IOS = 1417,
  Linux = 41,
  Mac = 28,
  Rigel = 34,
  Web = 1415,
  WindowsPhone = 1423
}

enum ClientType {
  CDLWorker = 'cdlworker',
  Desktop = 'desktop',
  Web = 'web'
}

// Reference https://github.com/lancedikson/bowser/blob/master/src/constants.js
export enum OsNames {
  Android = 'Android',
  Bada = 'Bada',
  BlackBerry = 'BlackBerry',
  ChromeOS = 'Chrome OS',
  Linux = 'Linux',
  MacOS = 'macOS',
  PlayStation4 = 'PlayStation 4',
  Roku = 'Roku',
  Tizen = 'Tizen',
  WebOS = 'WebOS',
  Windows = 'Windows',
  WindowsPhone = 'Windows Phone',
  iOS = 'iOS'
}

const getClientType = (): ClientType => {
  const userAgent: string = window.navigator.userAgent;

  return userAgent?.indexOf('Electron') !== -1
    ? ClientType.Desktop
    : userAgent?.indexOf('cdlworker') !== -1
    ? ClientType.CDLWorker
    : ClientType.Web;
};

const getOsPlatformId = (): number | void => {
  const clientType = getClientType();
  const userAgent: string = window.navigator.userAgent;
  const osName = bowser.getParser(userAgent).getOSName();

  if (OsNames.Linux === osName) {
    return PlatformId.Linux;
  } else if (OsNames.Android === osName) {
    return PlatformId.Android;
  } else if (OsNames.iOS === osName) {
    return PlatformId.IOS;
  } else if (OsNames.WindowsPhone === osName) {
    return PlatformId.WindowsPhone;
  } else if (OsNames.MacOS === osName) {
    return PlatformId.Mac;
  } else if (clientType === ClientType.Desktop) {
    return PlatformId.Desktop;
  } else if (clientType === ClientType.Web) {
    return PlatformId.Web;
  } else if (clientType === ClientType.CDLWorker) {
    return PlatformId.Rigel;
  }
};

export const getNavigationProperties = () => {
  const calculatedProperties: INavigationProperties = {};

  calculatedProperties.appPlatformId = String(getOsPlatformId());
  calculatedProperties.userAgent = window.navigator.userAgent;
  return calculatedProperties;
};

export interface INavigationProperties {
  appPlatformId?: string;
  userAgent?: string;
}
